import cloneDeep from 'lodash/cloneDeep';

import {items} from './consts';

import {QuestionBankItem} from './types';
import {SurveyPreset} from 'client/common/types/survey';

const visibleItems = items.filter(item => !item.hidden);

export function getInitialItems(preset: SurveyPreset): QuestionBankItem[] {
    return cloneDeep(visibleItems).filter(item => item.initial.includes(preset));
}
